import _ from "lodash";
import { useState, useEffect, useLayoutEffect, useContext } from "react";
import useFetch from "../../utils/useFetch";
import SectionTemplate from "../SectionTemplate";
import NavWrapper from "./NavWrapper";
import QuestionnaireSubSectionList from "./QuestionnaireSubSectionList";
import LoadingSpinner from "../../toolkit/LoadingSpinner";
import ErrorAlert from "../../toolkit/ErrorAlert";
import Introduction from "../Questionnaire/Introduction/Introduction";
import BaseURL from "../../utils/base-uri.json";
import ProgressBar from "../ProgressBar";
import { getOrgType } from "../../utils/Token";
import { QuestionnaireContext as QuestionnaireStore } from "../../store/questionnaire-context";
import { Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Button from "../../toolkit/ButtonV1";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/fvAxios";
// import Tooltip from "@mui/material/Tooltip";

// function getNavOptions({ id, text, status, metrics }) {
//   return { id, text, status,metrics };
// }
function mapInitialData(r) {
  return {
    id: r.sectionId,
    text: r.sectionName,
    status: r.isSectionCompleted === true ? "completed" : "pending",
    sectionType: r.sectionType,
    metrics: r.sectionQuestions === 0 ? null : r.sectionQuestionsCompleted + '/' + r.sectionQuestions,
    component: r.component,
    IsSectionCompleted: r.isSectionCompleted,
    HeaderTitle: r.sectionHeaderTitle,
    FooterTitle: r.sectionFooterTitle,
    HeaderContent: r.sectionHeader,
    FooterContent: r.sectionFooter,
    disabled: r.isDisable
  };
}

function getComponent(name) {
  switch (name) {
    case 31:
    case 0:
      return Introduction;
    default:
      return QuestionnaireSubSectionList;
  }
}

const params = new URLSearchParams(window.location.search);
const PQID = params.get("pqid");
const isMultiClientId = params.get("ClientId");
let navigatedSectionID = null;
const ID = params.get("ID");

export default function ({ dataUrl, selected, PQSTID, ViewMode, PQCLIENTID, ClientTemplate, pqId, isPaymentCompleted, languageId, pqStartDate, pqClientVendorRef, vendorname, ClientName, IsMultiple, dataload1, Obj, BalcllistClientId }) {
  const pqid = pqId ?? PQID;
  const [Refresh, setRefresh] = useState(true);
  const {
    data: resp,
    loading,
    error,
  } = useFetch(BaseURL.baseUrl + "Prequalification/PqSections?pqId=" + pqid + "&Refresh=" + Refresh); // TODO: remove localhost arg


  const [sections, setSections] = useState([]);
  const [sectionId, setSectionId] = useState(selected);
  const [section, setSection] = useState();
  const questionnaireStore = useContext(QuestionnaireStore);
  const params = new URLSearchParams(window.location.search);
  const tab = params.get("tab");
  const navigate = useNavigate();
  const _globalSectionId = params.get("sectionid");
  const [Incompletesection, setIncompletesection] = useState(false);
  const [IncompletesectionId, setIncompletesectionId] = useState('');
  const [LastSectionId, setLastSectionId] = useState('');
  const [CurrSectionId, setCurrSectionId] = useState('');
  const [HiddenSectionInfo, setHiddenSectionInfo] = useState([]);

  if (tab) {
    navigatedSectionID = params.get("sectionid");
  }

  const [navProps, setNavProps] = useState({
    options: sections,
    onChange: (sectionId) => {
      setSection(null);
      setSectionId(sectionId);

      setNavProps((prev) => {
        const cur = prev.options?.find((f) => f.id === sectionId);
        if (cur?.sectionType === 33) {
          axios
            .get("/Prequalification/GetHeaderFooter?sectionId=" + sectionId)
            .then((res) => {
              if (res.data.responseCode === 100) {
                setHiddenSectionInfo(
                  res?.data?.data?.filter((r) => r?.isHeader === true)
                );
              }
            })
            .catch(console.log);
        } else {
          setHiddenSectionInfo([]);
        }

        return prev;
      });
      
    },
    variant: "stepperNav",
  });
  const [sectionQuestions, setSectionQuestions] = useState([]);
  const [sectionQuestionsCompleted, setSectionQuestionsCompleted] = useState([]);


  useEffect(() => {
    const lastSection = sections[sections.length - 1];
    const cur = sections?.find((f) => f.id === section?.id);
    setLastSectionId(lastSection?.id);
    setCurrSectionId(cur?.id);
    setSection(sections.find((s) => s.id === sectionId));
  }, [sectionId, sections]);

  if (navigatedSectionID && sectionId && navigatedSectionID != sectionId && sections?.length > 0) {
    navProps.onChange((+navigatedSectionID));
  }

  useEffect(() => {
    if (navigatedSectionID && sectionId && section && navigatedSectionID == sectionId)
      navigatedSectionID = null;
  }, [section])


  var secId = sectionId;   //sectionId == null ? Incompletesection :
  if (!secId) secId = _globalSectionId;
  const newURL = window.location.pathname + `?pqid=${pqid}&ClientId=${isMultiClientId}&sectionid=${secId}`; //here 'BalcllistClientId' changed to 'isMultiClientId'
  if (Incompletesection == false) {
    window.history.pushState({}, "", newURL);
  }

  useLayoutEffect(() => {

    const globalSectionId = +(_globalSectionId ?? questionnaireStore?.currentSectionId);
    globalSectionId > 0 && sections.some((x) => x.id == globalSectionId)
      ? setSectionId(globalSectionId)
      : Incompletesection == true ? setSectionId(IncompletesectionId) : setSectionId(sections?.[0]?.id);   // setSectionId(sections?.[0]?.id);   Vendor First time came to the questionnaire In(Vendor portal)
  }, [navProps]);

  useEffect(() => {
    setNavProps((prev) => ({
      ...prev,
      options: sections,
    }));
  }, [sections]);

  // ABDUL FEE CAP START
  const [ISreachedFeecap, setISReachedFeecap] = useState();
  const data = (val) => {
    setISReachedFeecap(val)
    dataload1(val)

  }
  // ABDUL FEE CAP END



  useEffect(() => {
    if (resp?.data) {

      // Vendor First time came to the questionnaire In(Vendor portal)
      // if (getOrgType() == "Vendor" && sectionId == null) {
      //   const NotCompleatedSection = sections?.find((r) => r?.IsSectionCompleted == false)?.id;
      //   setIncompletesection(NotCompleatedSection);
      // }
      //
      const cur = resp?.data?.find((f) => f.sectionId == secId);
      if (cur?.sectionType === 33) {
        axios
          .get("/Prequalification/GetHeaderFooter?sectionId=" + cur?.sectionId)
          .then((res) => {
            if (res.data.responseCode === 100) {
              setHiddenSectionInfo(
                res?.data?.data?.filter((r) => r?.isHeader === true)
              );
            }
          })
          .catch(console.log);
      } else {
        setHiddenSectionInfo([]);
      }

      const NotCompleatedSection = resp?.data?.find((r) => r?.isSectionCompleted == false);
      const det = resp?.data?.find((r) => r?.sectionType == 3);
      const pos = resp?.data?.indexOf(det);

      resp?.data?.forEach((q, index) => {
        q.component = getComponent(q?.sectionType);
        q.isDisable = getOrgType() == "Vendor" && !Obj?.paymentReceived && pos < index;
        if (q.isDisable) {
          const newURL = window.location.pathname + `?pqid=${pqid}&ClientId=${isMultiClientId}&sectionid=${NotCompleatedSection?.sectionId}`; //here 'BalcllistClientId' changed to 'isMultiClientId'
          window.history.pushState({}, "", newURL);
        }
      });




      if (getOrgType() == "Vendor" && NotCompleatedSection) {
        // setSectionId(NotCompleatedSection?.sectionId);
        setIncompletesectionId(NotCompleatedSection?.sectionId);
        setIncompletesection(true);
      } else {
        setIncompletesection(false);
      }

      setSections(resp?.data?.map(mapInitialData) || []);
      setSectionQuestions(resp?.data?.reduce((a, r) => a = a + r.sectionQuestions, 0))
      setSectionQuestionsCompleted(resp?.data?.reduce((a, r) => a = a + r.sectionQuestionsCompleted, 0))
    }

  }, [resp, Obj?.paymentReceived]);

  const [showPop, setShowPop] = useState(false);
  function setNextActive(refreshSections, val) {
    const cur = sections?.find((f) => f.id === section?.id);
    const next = sections[sections?.indexOf(cur) + 1];
    const lastSection = sections[sections.length - 1];
    if (next) {
      // setScrollTabIntoView(true);
      questionnaireStore?.setCurrentSectionId(next?.id);
      if (refreshSections) {
        setRefresh(!Refresh);
      } else if (section?.sectionType == 34) {
        window.location.reload();
      }
      setSectionId(next?.id);
      setIncompletesection(''); // Vendor First time came to the questionnaire In(Vendor portal) 
    } else if (refreshSections) {
      //Vendor  "Finalize And Submit" Functionality ...
      if (val == true && getOrgType() == "Vendor") {
        setShowPop(true);
      } else {
        setRefresh(!Refresh);
      }
    } else if (lastSection?.id == cur?.id) {
      window.location.reload();
    }
  }

  const FinalizePopUpOpen = (val) => {
    if (val == true && getOrgType() == "Vendor") {
      setShowPop(true);
    } else {
      setRefresh(!Refresh);
    }
  }

  const LocationSectionReset = () => {
    setRefresh(!Refresh);
  }

  return (
    <>
      <Dialog
        open={showPop}
        onClose={() => setShowPop(false)}
      >
        <DialogTitle>
          Your questionnaire has been submitted for processing by FIRST, VERIFY. Click here to return to the Dashboard.
        </DialogTitle>
        <DialogActions className="w-100 d-flex">
          <Button
            onClick={() => {
              setShowPop(false);
              navigate("/DashBoard");
              window.location.reload();
            }}
            label="OK"
            sx={{ minHeight: "39px", minWidth: "90px" }}
            className="shadow-none "
            variant="contained"

          />
        </DialogActions>
      </Dialog>

      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <ErrorAlert severity="error" message={error} />
      ) : (
        <>
          <SectionTemplate
            navWrapper={true}
            isLink={true}
            percentComplete={(sectionQuestionsCompleted / sectionQuestions * 100)?.toFixed(0)}
            leftLabel={sectionQuestionsCompleted + " Complete / Out of " + sectionQuestions + " Total Questions " + " ( " + (sectionQuestionsCompleted / sectionQuestions * 100)?.toFixed(0) + "% Complete" + " ) "}
            rightLabel={""}
            navProps={{
              ...navProps,
              selected: sectionId,
            }}
          >
            {section?.id ? (
              section?.component ? (
                <div>
                  {(section?.HeaderContent || section?.HeaderTitle) && (
                    <>

                      {section?.sectionType == 4 && getOrgType() == "Client" ?
                        <Box
                          sx={{
                            backgroundColor: "#fff",
                            marginbottom: "20px",
                            position: "relative",
                            top: "6px",
                          }}
                          className="px-4 py-2 border rounded"

                        >
                          NOTE: DOCUMENTS WILL DISPLAY AFTER FIRST, VERIFY REVIEW
                        </Box>
                        :
                        <>
                          <Box
                            sx={{
                              backgroundColor: "#fff",
                              marginbottom: "20px",
                              position: "relative",
                              top: "6px",
                            }}
                            className="px-4 py-2 border rounded"
                            hidden={getOrgType() == "Client"}
                          >
                            <div >
                              {section?.HeaderTitle && <div className="d-flex">
                                <b
                                  className="w-100 my-2 rounded"
                                  style={{ color: "#667085" }}
                                >
                                  {/* {section?.HeaderTitle} */}
                                  <div
                                    style={{ overflowX: "hidden" }}
                                    dangerouslySetInnerHTML={{
                                      __html: section?.HeaderTitle,
                                    }}
                                  />
                                </b>
                              </div>}
                              <div
                                style={{ overflowX: "hidden" }}
                                dangerouslySetInnerHTML={{
                                  __html: section?.HeaderContent,
                                }}
                              />

                              {HiddenSectionInfo?.map((r, index) => (
                                <div key={index} className="mb-3">
                                  <div
                                    className="fw-bold w-100 my-2 rounded"
                                    style={{ color: "#667085" }}
                                    dangerouslySetInnerHTML={{ __html: r?.title }}
                                  />

                                  <div
                                    style={{ overflowX: "hidden" }}
                                    dangerouslySetInnerHTML={{ __html: r?.content }}
                                  />

                                </div>
                              ))}
                            </div>
                          </Box>
                        </>}
                    </>
                  )}
                  <section.component
                    dataUrl={section ? `${dataUrl}/${section?.id}` : ""}
                    Secid={section?.id}
                    IsSectionCompleted={section?.IsSectionCompleted}
                    Link={true}
                    SectionType={section?.sectionType}
                    HeaderTitle={section?.HeaderTitle}
                    FooterTitle={section?.FooterTitle}
                    HeaderContent={section?.HeaderContent}
                    FooterContent={section?.FooterContent}
                    SectionFooterTitle={section?.FooterTitle}
                    setNextSection={setNextActive}
                    FinalizePopUpOpen={FinalizePopUpOpen}
                    PqStatusID={PQSTID}
                    VIEWMODE={ViewMode}
                    PQCLIENTID={PQCLIENTID}
                    ClientTemplate={ClientTemplate}
                    languageId={languageId}
                    venName={vendorname?.vendorName}
                    pqStartDate={pqStartDate}
                    pqClientVendorRef={pqClientVendorRef}
                    PqClientName={ClientName}
                    IsMultiple={IsMultiple}
                    dataload={data} // ABDUL FEE CAP END
                    LocationSectionReset={LocationSectionReset}
                  />
                </div>
              ) : (
                <QuestionnaireSubSectionList
                  IsSectionCompleted={section?.IsSectionCompleted}
                  Link={true}
                  dataUrl={section ? `${dataUrl}/${section?.id}` : ""}
                  Secid={section?.id}
                  SectionType={section?.sectionType}
                  setNextSection={setNextActive}
                  FinalizePopUpOpen={FinalizePopUpOpen}
                  PqStatusID={PQSTID}
                  VIEWMODE={ViewMode}
                  PQCLIENTID={PQCLIENTID}
                  ClientTemplate={ClientTemplate}
                  pqId={pqId}
                  languageId={languageId}
                  venName={vendorname?.vendorName}
                  pqStartDate={pqStartDate}
                  pqClientVendorRef={pqClientVendorRef}
                  PqClientName={ClientName}
                  IsMultiple={IsMultiple}
                  dataload={data} // ABDUL FEE CAP END
                  LocationSectionReset={LocationSectionReset}
                  LastSectionId={LastSectionId}
                  CurrSectionId={CurrSectionId}
                />
              )

            ) : ""}

          </SectionTemplate>
        </>
      )}
    </>
  );
}